import { Injectable, OnDestroy } from '@angular/core';
import {DataService} from '../data.service';
import { BehaviorSubject, zip, Subject } from 'rxjs';
import { map, takeUntil, filter } from 'rxjs/operators';
import { FormGroup, FormControl } from '@angular/forms';
import { AuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class AwardsService implements OnDestroy {

  destroy$: Subject<boolean> = new Subject<boolean>();

  only_sp;
  me_points;

  total_pages;
  awards = null;
  sorting = 'created_at;asc';


  producers;

  params = {
    page: 1,
    direction: 'asc',
    sort: 'created_at',
    perPage: 12,
    se_top: null,
  };

  filters = new FormGroup({
    se_category_slug: new FormControl(null),
    se_subcategory_slug: new FormControl(null),
    se_expert: new FormControl(null),
    se_partner: new FormControl(null),
    points_from: new FormControl(null),
    points_to: new FormControl(null),
    'producer_id[]': new FormControl(null),
    search: new FormControl(null),
  });


  get categories() {
    return this.categoriesObs.value;
  }

  get favorites() {
    return this.favoritesObs.value;
  }

  categoriesObs = new BehaviorSubject<any>(null);
  categories$ = this.categoriesObs.asObservable();

  favoritesObs = new BehaviorSubject<any>(null);
  favorites$ = this.favoritesObs.asObservable();

  constructor(
    private dataService: DataService,
    private authService: AuthService
  ) {
    this.dataService.invoke(`/platform/award-producers`)
    .pipe(takeUntil(this.destroy$))
    .subscribe(res => {
      this.producers = res;
    });

    this.authService.me$
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      res => {

        if (res) {
          if (res.type === 'partner') {
            this.filters.get('se_expert').patchValue(true);
            this.filters.get('se_partner').patchValue(false);
          }

          if (res.type === 'se') {
            this.filters.get('se_expert').patchValue(true);
            this.filters.get('se_partner').patchValue(false);
          }

          if (res.type === 'se_top') {
            this.filters.get('se_expert').patchValue(false);
            this.filters.get('se_partner').patchValue(false);
          }
        }

      }
    );

  }

  ngOnDestroy() {
    // Unsubscribe from whatever used takeUntil(destroy$)
    this.destroy$.next(true);
    // Now let's also unsubscribe from the subject itself:
    this.destroy$.unsubscribe();
  }

  getData(clear?) {

    if (clear === true) {
      this.awards = null;
      this.params.page = 1;
    }

    const params = { ...this.params, ...this.filters.value };

    params.se_expert = params.se_expert ? 1 : null;
    params.se_partner = params.se_partner ? 1 : null;

    this.dataService
      .invoke('/platform/awards/business-salonexpert', 'get', params)
      .pipe(takeUntil(this.destroy$))
      .pipe(
        map((results) => {
          const awards = [];
          this.total_pages = results.total_pages;
          results.data.forEach((award) => {

            if (award.name) {
              award.name = award.name.replace(/\&amp;/gm, '&');
            }

            if (award.model) {
              award.model = award.model.replace(/\&amp;/gm, '&');
            }


            awards.push(award);
          });

          if (this.awards === null) {
            this.awards = awards;
          } else {
            this.awards.push(...awards);
          }
        })
      )
      .subscribe(() => {
        return this.awards;
      });

  }

  getAwardDetails(slug) {
    return this.dataService.invoke(`/platform/award/${slug}`).pipe(map(award => {

      if (award.name) {
        award.name = award.name.replace(/\&amp;/gm, '&');
      }

      if (award.model) {
        award.model = award.model.replace(/\&amp;/gm, '&');
      }

      if (award.description) {
        award.description = award.description.replace(/\&amp;/gm, '&');
      }

      return award;
    }));
  }

  setProducer(producer) {
    const current = this.filters.get('producer_id[]').value;
    if (current == producer) {
      this.filters.get('producer_id[]').patchValue(null);
    } else {
      this.filters.get('producer_id[]').patchValue(producer);
    }

    this.getData(true);
  }

  setSorting(sort) {
    this.sorting = sort;
    const sorting = sort.split(';');
    this.params.direction = sorting[1];
    this.params.sort = sorting[0];
    this.params.page = 1;
    this.getData(true);
  }

  // async getCategories() {

  //   if (!this.categoriesObs.value) {
  //     await this.dataService.invoke(`/salonexpert-business/award-categories`)
  //     .subscribe(
  //       res => {
  //         this.categoriesObs.next(res);
  //         return res;
  //         // resolve(true)
  //       },
  //       err => {
  //         // reject(err);
  //         console.error(err);
  //       }
  //     );
  //   } else {
  //     return this.categoriesObs.value;
  //   }
  // }

  getPromiseCategories() {
    return new Promise((resolve, reject) => {
      this.dataService.invoke(`/salonexpert-business/award-categories`)
      .subscribe(
        res => {
          this.categoriesObs.next(res);
          resolve(res);
        },
        err => {
          reject(err);
          console.error(err);
        }
      );
    });
  }

  async getFavorites(force = false) {
    if (!this.favoritesObs.value || force) {
      await this.dataService.invoke(`/salonexpert-business/client/award-favorites`)
      .subscribe(
        res => {
          this.favoritesObs.next(res);
          return res;
        },
        err => {
          console.error(err);
        }
      );
    } else {
      return this.favoritesObs.value;
    }
  }

}
